/* eslint-disable react-hooks/exhaustive-deps */
import { useNavigate } from '@tanstack/react-router';
import { useCallback } from 'react';

import { Container } from '@/components/custom/container';
import { Avatar } from '@/components/ui/avatar';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';
import { useMediaQuery } from '@/lib/hooks/useMediaQuery';
import { useStore } from '@/stores';
import { useDashboardContext } from '@/stores/context/dashboard-layout-context';
import { BREAKPOINTS } from '@/lib/constants/breakpoints';

import MenuProfile from './menu-profile';

const UserProfile = () => {
  const isMediumView = useMediaQuery(BREAKPOINTS.md);
  const navigate = useNavigate();
  const userProfile = useStore((state) => state.profile);
  const { isOpenDropdown, toggleDropdown } = useDashboardContext();

  const onToggleProfile = useCallback(() => {
    if (!isMediumView) navigate({ to: '/profile' });
    else toggleDropdown();
  }, []);

  return (
    <Container>
      <DropdownMenu open={isOpenDropdown}>
        <DropdownMenuTrigger onClick={onToggleProfile} className="cursor-pointer">
          <Avatar
            data-testid="user-avatar"
            className="bg-brand-blue h-9 w-9 items-center justify-center"
          >
            <span className="text-lg font-bold text-white capitalize">
              {userProfile?.name ? userProfile.name.charAt(0) : '-'}
            </span>
          </Avatar>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" onInteractOutside={toggleDropdown}>
          <MenuProfile />
        </DropdownMenuContent>
      </DropdownMenu>
    </Container>
  );
};

export default UserProfile;
